import React, { useCallback } from 'react';
import { isSafari } from 'react-device-detect';
import { RequiredIosSafariPage } from 'views/pages/errors/RequireIphonePage';

export const RequiredIosSafari: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const isTouchable = useCallback(() => {
    return 'ontouchend' in document;
  }, []);

  // isMobileSafariだとChrome(iPadOS)でtrueを返してしまうのでisSafari && isTouchableで判定する
  // https://github.com/duskload/react-device-detect/issues/106
  return isSafari && isTouchable() ? (
    <>{children}</>
  ) : (
    <RequiredIosSafariPage />
  );
};
